import { combineReducers } from 'redux';

import projectListReducer from 'src/app/projects/views/project-list/state/projectListSlice';
import newProjectDefinitionReducer from 'src/app/projects/views/new-project-definition/state/newProjectDefinitionSlice';
import siteFilesReducer from 'src/app/projects/views/site-files/state/siteFilesSlice';

export default combineReducers({
    projectList: projectListReducer,
    newProjectDefinition: newProjectDefinitionReducer,
    siteFiles: siteFilesReducer,
});
